<template >
  <div id="edit-index">
    <header><img src="@/assets/img/logo.png" alt=""></header>
        <div class="title-area">
          <h2>會員資料修改</h2>
        </div>
    <div class="container">
      <div class="wrapper">
        <div class="form-area">
          <div class="form">
            <div class="title"><span class="form-title">姓名</span></div>
              <div class="input">
                <ud-input v-model="user.name" placeholder="請輸入"></ud-input>
              </div>
          </div>
          <div class="form">
            <div class="title"><span class="form-title">手機號碼</span></div>
              <div class="input">
                <ud-input v-model="user.phone" disabled></ud-input>
              </div>
          </div>
          <div class="flex">
            <div class="form flex-5">
            <div class="title"><span class="form-title">生日</span></div>
              <div class="input">
                <ud-input v-model="user.birthday" disabled></ud-input>
              </div>
            </div>
            <div class="form flex-5">
            <div class="title"><span class="form-title">性別</span></div>
              <div class="input">
                <ud-select class="select-option" v-model='user.gender' :options="genderOptions"></ud-select>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="form flex-3">
              <div class="title"><span class="form-title">郵遞區號</span></div>
              <div class="input">
                <ud-input v-model="user.postCode" placeholder="請輸入"></ud-input>
              </div>
            </div>
            <div class="form flex-3">
                <div class="title"><span class="form-title">縣市</span></div>
                <div class="input">
                    <select
                    class="custom-select"
                    v-model="user.city"
                  >
                    <option value="" disabled selected>請選擇</option>
                    <option v-for="(area, city) in cities" :value="city" :key="city.id">
                      {{ city }}
                    </option>
                  </select>
                </div>
            </div>
            <div class="form flex-3">
                <div class="title"><span class="form-title">區域</span></div>
                <div class="input">
                    <select
                    class="custom-select"
                    v-model="user.area"
                  >
                      <option value="" disabled selected>請選擇</option>
                      <option v-for="(areacoce, area) in cities[user.city]" :value="area" :key="area.id">
                        {{ area }}
                      </option>
                    </select>
                  
                </div>
            </div>
          </div>
          <div class="form">
            <div class="title"><span class="form-title">詳細地址</span></div>
              <div class="input">
                <ud-input v-model="user.address" placeholder="請輸入"></ud-input>
              </div>
          </div>
          <div class="flex">
            <div class="form flex-5">
            <div class="title"><span class="form-title">身高</span></div>
              <div class="input">
                <ud-input v-model="user.height" placeholder="請輸入"></ud-input>
              </div>
            </div>
            <div class="form flex-5">
            <div class="title"><span class="form-title">體重</span></div>
              <div class="input">
                <ud-input v-model="user.weight" placeholder="請輸入"></ud-input>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="form flex-5">
            <div class="title"><span class="form-title">婚姻</span></div>
              <div class="input">
               <ud-select  v-model="user.marriage" :options="marriageOptions"></ud-select>
              </div>
            </div>
            <div class="form flex-5">
            <div class="title"><span class="form-title">學歷</span></div>
              <div class="input">
                <ud-select v-model="user.education" :options="educationOptions"></ud-select>
              </div>
            </div>
          </div>
          <div class="form">
            <div class="title"><span class="form-title">喜好品牌</span></div>
              <div class="input">
                <ud-input v-model="user.favBrand" placeholder="請輸入喜好品牌(如有多個品牌請用;區隔)"></ud-input>
              </div>
          </div>
          <div class="form">
            <div class="title"><span class="form-title">喜好運動</span></div>
              <div class="input">
                  <select
                    class="custom-select multiple"
                    multiple
                    size="1"
                    v-model="user.hobby"
                  >
                    <option value="" disabled>請選擇</option>
                    <option v-for="hobby in hobbyList" :value="hobby.code" :key="hobby.id">
                      {{ hobby.title }}
                    </option>
                  </select>
              </div>
          </div>
          
        </div>
        <div class="button-area">
          <button class="button2" type="submit" @click="submitForm()">
            確認修改<span><img src="@/assets/img/next.png" alt="" /></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/utils/Api';

export default {
  name: 'edit',
  components: {
  },
  data() {
    return {
      api: {},
      user: {
        name: "",
        phone: "",
        birthday: "",
        gender: "",
        postCode: "",
        city: "",
        area: "",
        address: "",
        height: "",
        weight: "",
        marriage: "",
        education: "",
        favBrand: [],
        hobby:[],
      },
      genderOptions: [
        { label: "男性", value: "M" },
        { label: "女性", value: "F" },
      ],
      cities: {
        基隆市: {
          仁愛區: "200",
          信義區: "201",
          中正區: "202",
          中山區: "203",
          安樂區: "204",
          暖暖區: "205",
          七堵區: "206",
        },
        台北市: {
          中正區: "100",
          大同區: "103",
          中山區: "104",
          松山區: "105",
          大安區: "106",
          萬華區: "108",
          信義區: "110",
          士林區: "111",
          北投區: "112",
          內湖區: "114",
          南港區: "115",
          文山區: "116",
        },
        新北市: {
          萬里區: "207",
          金山區: "208",
          板橋區: "220",
          汐止區: "221",
          深坑區: "222",
          石碇區: "223",
          瑞芳區: "224",
          平溪區: "226",
          雙溪區: "227",
          貢寮區: "228",
          新店區: "231",
          坪林區: "232",
          烏來區: "233",
          永和區: "234",
          中和區: "235",
          土城區: "236",
          三峽區: "237",
          樹林區: "238",
          鶯歌區: "239",
          三重區: "241",
          新莊區: "242",
          泰山區: "243",
          林口區: "244",
          蘆洲區: "247",
          五股區: "248",
          八里區: "249",
          淡水區: "251",
          三芝區: "252",
          石門區: "253",
        },
        宜蘭縣: {
          宜蘭市: "260",
          頭城鎮: "261",
          礁溪鄉: "262",
          壯圍鄉: "263",
          員山鄉: "264",
          羅東鎮: "265",
          三星鄉: "266",
          大同鄉: "267",
          五結鄉: "268",
          冬山鄉: "269",
          蘇澳鎮: "270",
          南澳鄉: "272",
          釣魚台列嶼: "290",
        },
        新竹市: { 東區: "300", 北區: "300", 香山區: "300" },
        新竹縣: {
          竹北市: "302",
          湖口鄉: "303",
          新豐鄉: "304",
          新埔鎮: "305",
          關西鎮: "306",
          芎林鄉: "307",
          寶山鄉: "308",
          竹東鎮: "310",
          五峰鄉: "311",
          橫山鄉: "312",
          尖石鄉: "313",
          北埔鄉: "314",
          峨眉鄉: "315",
        },
        桃園市: {
          中壢區: "320",
          平鎮區: "324",
          龍潭區: "325",
          楊梅區: "326",
          新屋區: "327",
          觀音區: "328",
          桃園區: "330",
          龜山區: "333",
          八德區: "334",
          大溪區: "335",
          復興區: "336",
          大園區: "337",
          蘆竹區: "338",
        },
        苗栗縣: {
          竹南鎮: "350",
          頭份市: "351",
          三灣鄉: "352",
          南庄鄉: "353",
          獅潭鄉: "354",
          後龍鎮: "356",
          通霄鎮: "357",
          苑裡鎮: "358",
          苗栗市: "360",
          造橋鄉: "361",
          頭屋鄉: "362",
          公館鄉: "363",
          大湖鄉: "364",
          泰安鄉: "365",
          銅鑼鄉: "366",
          三義鄉: "367",
          西湖鄉: "368",
          卓蘭鎮: "369",
        },
        台中市: {
          中區: "400",
          東區: "401",
          南區: "402",
          西區: "403",
          北區: "404",
          北屯區: "406",
          西屯區: "407",
          南屯區: "408",
          太平區: "411",
          大里區: "412",
          霧峰區: "413",
          烏日區: "414",
          豐原區: "420",
          后里區: "421",
          石岡區: "422",
          東勢區: "423",
          和平區: "424",
          新社區: "426",
          潭子區: "427",
          大雅區: "428",
          神岡區: "429",
          大肚區: "432",
          沙鹿區: "433",
          龍井區: "434",
          梧棲區: "435",
          清水區: "436",
          大甲區: "437",
          外埔區: "438",
          大安區: "439",
        },
        彰化縣: {
          彰化市: "500",
          芬園鄉: "502",
          花壇鄉: "503",
          秀水鄉: "504",
          鹿港鎮: "505",
          福興鄉: "506",
          線西鄉: "507",
          和美鎮: "508",
          伸港鄉: "509",
          員林市: "510",
          社頭鄉: "511",
          永靖鄉: "512",
          埔心鄉: "513",
          溪湖鎮: "514",
          大村鄉: "515",
          埔鹽鄉: "516",
          田中鎮: "520",
          北斗鎮: "521",
          田尾鄉: "522",
          埤頭鄉: "523",
          溪州鄉: "524",
          竹塘鄉: "525",
          二林鎮: "526",
          大城鄉: "527",
          芳苑鄉: "528",
          二水鄉: "530",
        },
        南投縣: {
          南投市: "540",
          中寮鄉: "541",
          草屯鎮: "542",
          國姓鄉: "544",
          埔里鎮: "545",
          仁愛鄉: "546",
          名間鄉: "551",
          集集鎮: "552",
          水里鄉: "553",
          魚池鄉: "555",
          信義鄉: "556",
          竹山鎮: "557",
          鹿谷鄉: "558",
        },
        嘉義市: { 東區: "600", 西區: "600" },
        嘉義縣: {
          番路鄉: "602",
          梅山鄉: "603",
          竹崎鄉: "604",
          阿里山鄉: "605",
          中埔鄉: "606",
          大埔鄉: "607",
          水上鄉: "608",
          鹿草鄉: "611",
          太保市: "612",
          朴子市: "613",
          東石鄉: "614",
          六腳鄉: "615",
          新港鄉: "616",
          民雄鄉: "621",
          大林鎮: "622",
          溪口鄉: "623",
          義竹鄉: "624",
          布袋鎮: "625",
        },
        雲林縣: {
          斗南鎮: "630",
          大埤鄉: "631",
          虎尾鎮: "632",
          土庫鎮: "633",
          褒忠鄉: "634",
          東勢鄉: "635",
          台西鄉: "636",
          崙背鄉: "637",
          麥寮鄉: "638",
          斗六市: "640",
          林內鄉: "643",
          古坑鄉: "646",
          莿桐鄉: "647",
          西螺鎮: "648",
          二崙鄉: "649",
          北港鎮: "651",
          水林鄉: "652",
          口湖鄉: "653",
          四湖鄉: "654",
          元長鄉: "655",
        },
        台南市: {
          中西區: "700",
          東區: "701",
          南區: "702",
          北區: "704",
          安平區: "708",
          安南區: "709",
          永康區: "710",
          歸仁區: "711",
          新化區: "712",
          左鎮區: "713",
          玉井區: "714",
          楠西區: "715",
          南化區: "716",
          仁德區: "717",
          關廟區: "718",
          龍崎區: "719",
          官田區: "720",
          麻豆區: "721",
          佳里區: "722",
          西港區: "723",
          七股區: "724",
          將軍區: "725",
          學甲區: "726",
          北門區: "727",
          新營區: "730",
          後壁區: "731",
          白河區: "732",
          東山區: "733",
          六甲區: "734",
          下營區: "735",
          柳營區: "736",
          鹽水區: "737",
          善化區: "741",
          大內區: "742",
          山上區: "743",
          新市區: "744",
          安定區: "745",
        },
        高雄市: {
          新興區: "800",
          前金區: "801",
          苓雅區: "802",
          鹽埕區: "803",
          鼓山區: "804",
          旗津區: "805",
          前鎮區: "806",
          三民區: "807",
          楠梓區: "811",
          小港區: "812",
          左營區: "813",
          仁武區: "814",
          大社區: "815",
          東沙群島: "817",
          南沙群島: "819",
          岡山區: "820",
          路竹區: "821",
          阿蓮區: "822",
          田寮區: "823",
          燕巢區: "824",
          橋頭區: "825",
          梓官區: "826",
          彌陀區: "827",
          永安區: "828",
          湖內區: "829",
          鳳山區: "830",
          大寮區: "831",
          林園區: "832",
          鳥松區: "833",
          大樹區: "840",
          旗山區: "842",
          美濃區: "843",
          六龜區: "844",
          內門區: "845",
          杉林區: "846",
          甲仙區: "847",
          桃源區: "848",
          那瑪夏區: "849",
          茂林區: "851",
          茄萣區: "852",
        },
        屏東縣: {
          屏東市: "900",
          三地門鄉: "901",
          霧台鄉: "902",
          瑪家鄉: "903",
          九如鄉: "904",
          里港鄉: "905",
          高樹鄉: "906",
          鹽埔鄉: "907",
          長治鄉: "908",
          麟洛鄉: "909",
          竹田鄉: "911",
          內埔鄉: "912",
          萬丹鄉: "913",
          潮州鎮: "920",
          泰武鄉: "921",
          來義鄉: "922",
          萬巒鄉: "923",
          崁頂鄉: "924",
          新埤鄉: "925",
          南州鄉: "926",
          林邊鄉: "927",
          東港鎮: "928",
          琉球鄉: "929",
          佳冬鄉: "931",
          新園鄉: "932",
          枋寮鄉: "940",
          枋山鄉: "941",
          春日鄉: "942",
          獅子鄉: "943",
          車城鄉: "944",
          牡丹鄉: "945",
          恆春鎮: "946",
          滿州鄉: "947",
        },
        台東縣: {
          台東市: "950",
          綠島鄉: "951",
          蘭嶼鄉: "952",
          延平鄉: "953",
          卑南鄉: "954",
          鹿野鄉: "955",
          關山鎮: "956",
          海端鄉: "957",
          池上鄉: "958",
          東河鄉: "959",
          成功鎮: "961",
          長濱鄉: "962",
          太麻里鄉: "963",
          金峰鄉: "964",
          大武鄉: "965",
          達仁鄉: "966",
        },
        花蓮縣: {
          花蓮市: "970",
          新城鄉: "971",
          秀林鄉: "972",
          吉安鄉: "973",
          壽豐鄉: "974",
          鳳林鎮: "975",
          光復鄉: "976",
          豐濱鄉: "977",
          瑞穗鄉: "978",
          萬榮鄉: "979",
          玉里鎮: "981",
          卓溪鄉: "982",
          富里鄉: "983",
        },
        金門縣: {
          金沙鎮: "890",
          金湖鎮: "891",
          金寧鄉: "892",
          金城鎮: "893",
          烈嶼鄉: "894",
          烏坵鄉: "896",
        },
        連江縣: {
          南竿鄉: "209",
          北竿鄉: "210",
          莒光鄉: "211",
          東引鄉: "212",
        },
        澎湖縣: {
          馬公市: "880",
          西嶼鄉: "881",
          望安鄉: "882",
          七美鄉: "883",
          白沙鄉: "884",
          湖西鄉: "885",
        },
      },
      marriageOptions:[
        { label: "是", value: "Y" },
        { label: "否", value: "N" },
      ],
      educationOptions:[
        { label: "國中以下", value: "01" },
        { label: "高中(職)", value: "02" },
        { label: "大學(專)", value: "03" },
        { label: "碩士", value: "04" },
        { label: "博士", value: "05" },
      ],
      hobbyList: [
        {
          code: "01",
          title: "游泳 Swimming",
        },
        {
          code: "02",
          title: "潛水 Scuba Diving",
        },
        {
          code: "03",
          title: "跑步 Running",
        },
        {
          code: "04",
          title: "健走 Walking",
        },
        {
          code: "05",
          title: "鐵人三項 Triathlon",
        },
        {
          code: "06",
          title: "自行車 Cycling",
        },
        {
          code: "07",
          title: "羽球 Badminton",
        },
        {
          code: "08",
          title: "棒球 Baseball",
        },
        {
          code: "09",
          title: "籃球 Basketball",
        },
        {
          code: "10",
          title: "足球 Football",
        },
        {
          code: "11",
          title: "壁球 Squash",
        },
        {
          code: "12",
          title: "桌球 Table Tennis",
        },
        {
          code: "13",
          title: "網球 Tennis",
        },
        {
          code: "14",
          title: "高爾夫 Golf",
        },
        {
          code: "15",
          title: "滑雪 Ski",
        },
        {
          code: "16",
          title: "登山 Hiking",
        },
        {
          code: "17",
          title: "露營 Camping",
        },
        {
          code: "18",
          title: "攀岩 Climbing",
        },
        {
          code: "19",
          title: "拳擊 Boxing",
        },
        {
          code: "20",
          title: "瑜珈 Yoga",
        },
        {
          code: "21",
          title: "有氧運動 Aerobic",
        },
        {
          code: "22",
          title: "訓練訓練 / 核心運動 Fitness/Training",
        },
        {
          code: "23",
          title: "休閒 Lifestyle",
        },
        {
          code: "24",
          title: "衝浪 Surfing",
        },
        {
          code: "25",
          title: "滑板 Skateboarding",
        },
        {
          code: "26",
          title: "綜合體育 Multi Sports",
        },
        {
          code: "27",
          title: "越野跑 Trail Running",
        },
        {
          code: "28",
          title: "水上運動",
        },
        {
          code: "99",
          title: "其他 Other",
        },
      ],
      originUser: {}, // 最原始資料，用於比對資料做更新用
    }
  },
  mounted() {
    this.initial();
  },
  computed: {

  },
  watch: {
    "user.hobby": function (newVal, oldVal) {
      this.hobbyLimitor(newVal, oldVal);
    }
  },
  methods: {
    hobbyLimitor(newVal, oldVal) {
      if (newVal.length > 3) {
        this.$swal({
          icon: "error",
          text: "喜好運動不能超過三個",
        });
        this.user.hobby = oldVal;
      }
    },
    async submitForm() {
      let resultObj = this.checkDiff();

      // name, address, favBrand -> 需要正規化字串不可有非文字
      // height, weight 必須為數字
      let errors = [];

      Object.keys(resultObj).forEach(key => {

        switch (key) {
          case 'name':
            if (! /^[a-zA-Z0-9\u4e00-\u9fa5]+$/.test(resultObj[key])) {
              errors.push('姓名 輸入不可有特殊字元');
            }
            break;
          case 'address':
            if (! /^[a-zA-Z0-9\u4e00-\u9fa5\-\,\.]*$/.test(resultObj[key])) {
              errors.push('詳細地址 輸入不可有特殊字元');
            }
            break;
          case 'favBrand':
            if (! /^[a-zA-Z0-9\u4e00-\u9fa5\;\,]*$/.test(resultObj[key])) {
              errors.push('喜好品牌 輸入不可有特殊字元');
            }
            break;
          case 'height':
            if (! /^\d*(\.*)\d*$/.test(resultObj[key])) {
              errors.push('身高 輸入只能是數字');
            }
            break;
          case 'weight':
            if (! /^\d*(\.*)\d*$/.test(resultObj[key])) {
              errors.push('體重 輸入只能是數字');
            }
            break;
          case 'postCode':
            if (parseInt(resultObj[key]).toString() === '') {
              return ;
            }

            if (! /^\d{3}(\d{2})*$/.test(resultObj[key])) {
              errors.push('郵遞區號 輸入只能是數字且長度為 3 或 5 碼');
            }
            break;
        }

      })

      if (errors.length > 0) {
        this.$swal({
          icon: "error",
          html: errors.join("<br />"),
        });

        return ;
      }

      // 有修改的選項
      if (Object.keys(resultObj).length !== 0) {
        await this.api.updateMember(resultObj);
      }
      await this.$swal({
        icon: "success",
        title: "更新成功",
        showConfirmButton: false,
        timer: 1500
      });
      this.$router.push("home");
    },
    async initial() {
      let uid = this.$root.$data.uid;
      let accessToken = this.$root.$data.accessToken;

      this.api = new Api(uid, accessToken);
      
      let { data: { data } } = await this.api.getProfile();
      this.originUser = Object.assign({}, data);
      this.user = Object.assign(this.user, data);
    },
    /** 取得比對後差異的結果 */
    checkDiff() {
      let origin = this.originUser;
      let newData = this.user;
      let changeObj = {};

      // 要比對的欄位除去 手機與生日
      let willCheckFields = Object.keys(origin).filter(key => (key !== 'phone') && (key !== 'birthday'));
      for(let field of willCheckFields) {
        if (origin[field] !== newData[field]) {
          changeObj[field] = newData[field];
        }
      }

      return changeObj;
    }
  },
};
</script>

<style scoped>
.container {
  padding: 0;
  overflow: hidden;
}
.title-area {
  padding: 16px 0 16px 0;
  /* background: #000; */
  box-shadow: 0px 3px 4px -2px rgba(158, 158, 159, 0.38);
  text-align: center;
}
.title-area h2 {
  color: #9e9e9f;
  font-size: 20px;
  margin: 0;
}
.form-area {
  padding: 22px 7% 10px 7%;
}
.form {
  margin-bottom: 15px;
}
.input {
  padding: 0 3px;
}
.flex {
  display: flex;
}
.flex-5 {
  flex: 0 0 50%;
  -webkit-flex: 0 0 50%;
}
.flex-3 {
  flex: 0 0 33.33%;
  -webkit-flex: 0 0 33.33%;
}
.title {
  text-align: start;
  padding-left: 4px;
  margin-bottom: 4px;
}
.ud-select:before {
    content: "";
    width: 100%;
    height: 100%;
    background: url(../assets/img/select-arrow.png);
    background-position: right 0.7rem center;
    background-repeat: no-repeat;
    background-size: 14.5%;
    border-color: none;
    border-style: none;
    border-width: none;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    right: 0;
    margin-top: 1px;
    position: absolute;
    z-index: 1;
    pointer-events: none; }
 .custom-select, .select-option-multiple {
    appearance: none;
    border-radius: 10px;
    border: 1px solid #9e9e9f;
    background-color: #fff;
    font-size: 14px;
    padding: 5px 10px;
    width: 100%;
    margin: 0;
    min-height: 48px;
    transition: border 0.2s ease;
    cursor: pointer; }
 .custom-select option {
      color: #333; }
     .custom-select:focus {
      outline: 0;
      border: 1px solid #000; }
     .custom-select[data-placeholder-selected] {
      color: #a8a8a8; }
     .custom-select[multiple] option:nth-of-type(1) {
      color: #a8a8a8; }
.custom-select {
    color: #9E9E9F;
    border-radius: 10px;
    border: 1px solid #9E9E9F;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    background: url(../assets/img/select-arrow.png);
    background-position: right 0.7rem center;
    background-color: transparent;
    background-repeat: no-repeat;
    background-size: 22%;
}
.custom-select.multiple {
   background-size: 7.5% !important;
}
.button-area {
    padding: 0 20%;
    padding-bottom: 30px;
}
.button2 {
    width: 100%;
    cursor: pointer;
    position: relative;
    border: none;
    outline: none !important;
    background-color: #fff;
    color: #006FB2;
    border: 2px solid #006FB2;
    border-radius: 50px;
    padding: 6px 10px;
    letter-spacing: 1px;
    font-size: 14px;
    font-weight: bold;
    min-width: 40%;
    -webkit-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
}
.button2 span {
    display: inline-block;
    background-color: #006FB2;
    border-radius: 50px;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 5px;
    top: 50%;
    -webkit-transform: translate(0%, -50%);
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);
}
.button2 span img {
    width: 14px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
</style>